/** Copy from the visible input inside the modal, including HTTP/mobile browsers. */
export async function copyInvitationLink(input, navigatorObject = globalThis.navigator) {
  const previousFocus = input.ownerDocument.activeElement;
  const restoreFocus = () => { try { previousFocus?.focus({ preventScroll: true }); } catch { /* Copy already succeeded. */ } };
  try {
    if (typeof navigatorObject?.clipboard?.writeText === 'function') {
      await navigatorObject.clipboard.writeText(input.value);
      restoreFocus();
      return true;
    }
  } catch { /* A blocked Clipboard API can still allow selection-based copying. */ }
  try {
    input.focus({ preventScroll: true });
    input.select();
    input.setSelectionRange(0, input.value.length);
    // On HTTP the Clipboard API is absent, so this runs synchronously during
    // the tap. Using the modal input avoids inert off-screen copy elements.
    if (input.ownerDocument.execCommand?.('copy') === true) {
      restoreFocus();
      return true;
    }
  } catch { /* Both automatic clipboard methods are unavailable. */ }
  // Keep the visible link selected for the browser's long-press Copy action.
  return false;
}
